var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { xs: 20, sm: 9, md: 7, lg: 6, xl: 4 } },
            [
              _c("admin-menu", {
                on: {
                  addUser: _vm.addUserEvent,
                  modifyUser: _vm.modifyUserEvent,
                  modifyRole: _vm.modifyRoleEvent,
                  addForeignUser: _vm.addForeignUserEvent,
                  addUniversity: _vm.addUniversityEvent
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { xs: 24, sm: 24, md: 16, lg: 16, xl: 16 } },
            [
              _c("application-search", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchVisible,
                    expression: "searchVisible"
                  }
                ]
              }),
              _vm._v(" "),
              _c("search-uni", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchUniVisible,
                    expression: "searchUniVisible"
                  }
                ]
              }),
              _vm._v(" "),
              _c("foreign-user-search", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.searchForeignVisible,
                    expression: "searchForeignVisible"
                  }
                ]
              }),
              _vm._v(" "),
              _c("statistics", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.statsVisible,
                    expression: "statsVisible"
                  }
                ]
              }),
              _vm._v(" "),
              _c("register-form", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value:
                      _vm.addUser ||
                      _vm.modifyUser ||
                      _vm.modifyRole ||
                      _vm.addForeignUser,
                    expression:
                      "addUser || modifyUser || modifyRole || addForeignUser"
                  },
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.loadingUser,
                    expression: "loadingUser"
                  }
                ],
                attrs: {
                  addUser: _vm.addUser,
                  addForeignUser: _vm.addForeignUser,
                  modifyUser: _vm.modifyUser,
                  modifyRole: _vm.modifyRole,
                  userData: _vm.modifyUserData,
                  roleId: _vm.roleId,
                  modifyFromUser: _vm.modifyFromUser,
                  academicAreas: _vm.academicAreas
                },
                on: { hideForm: _vm.hideForm }
              }),
              _vm._v(" "),
              _vm.addUniversity
                ? _c("manage-db", {
                    attrs: { addUniversity: _vm.addUniversity },
                    on: { hideForm: _vm.hideForm }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-17dfb9ef", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17dfb9ef","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = null
// module chunks = 